<template>
  <div>
    <div class="l-header-audit">
      <div class="l-header-audit__inner">
        <div class="l-header-audit__data">
          <div class="audit-data">
            <div class="audit-data__info">
              <div class="name">
                <span class="audit-data-name js-audit-data-name">{{ this.diagTitle }}</span>
                <a @click="changeDiagTitle(true)" class="link-arrow" style="margin-left: 2rem;">監査名の変更</a>
              </div>
              <div class="corse">
                {{ this.diagCourseName }}
              </div>
              <div class="progress">
                <p><strong>{{ progress }}％</strong> {{ answeredDiagResultItemsCountTotal }}/{{ diagItemsCountTotal }}</p>
                <div class="progress_bar">
                  <span :style="'width: ' + progress + '%'"></span>
                </div>
              </div>
              <div class="label-update"><span v-show="diagRevisionFlg">UPDATE</span></div>
            </div>
          </div>
        </div>
        <div class="btn-create-new_wh" @click="goNewDiag()"><a>監査の新規作成</a></div>
      </div>
    </div>
    <transition name="diagtitlechange-fade">
      <DiagTitleChangeModal
        v-show="execChangeDiagTitle"
        :diagResultId="diagResultId"
        @cancel-diag-title-change="changeDiagTitle(false)"
        @set-new-diag-title="setNewDiagTitle"
      ></DiagTitleChangeModal>
    </transition>
  </div>
</template>

<script>
import DiagTitleChangeModal from '@/components/pages/diag/DiagTitleChangeModal.vue';

export default {
  components: {
    DiagTitleChangeModal
  },
  data() {
    return {
      execChangeDiagTitle: false,
      isAdmin: false,
    }
  },
  props: {
    answeredDiagResultItemsCountTotal: {},
    diagItemsCountTotal: {},
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.getters['diag/getTitle'];
    },
    diagCourseName() {
      return this.$store.getters['diag/getDiagCourseName'];
    },
    diagCourseId() {
      return this.$store.getters['diag/getDiagCourseId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    progress() {
      return Math.floor((this.answeredDiagResultItemsCountTotal / this.diagItemsCountTotal) * 100);
    },
    diagRevisionFlg() {
      return this.$store.getters['diag/getDiagRevisionFlg'];
    },
    sectionNotUseFlag() {
      return this.$store.getters['diag/getSectionNotUseFlag'];
    },
  },
  watch: {
    async corpId() {
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$router.push({ name: 'diag-top' });
    }
  },
  created: async function () {
    const authority = await this.$store.dispatch('auth/getAuthority');
    this.isAdmin = authority.isAdmin;
  },
  methods: {
    goDiagList() {
      this.$store.dispatch('diag/setCorpId', this.corpId);
      this.$router.push({ name: 'diag-top' });
    },
    goDiagManagementList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    goTaskList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'task-list' });
    },
    async goDiagForm() {
      if (!this.sectionNotUseFlag) {
        this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.diagCourseId } });
      } else {
        this.$router.push({ name: 'option-diag-answer-input', query: { diagCourseId: this.diagCourseId } });
      }
    },
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
    },
    setNewDiagTitle(data) {
      this.$store.dispatch('diag/setTitle', data.title);
    },
    goNewDiag() {
      this.$router.push({ name: 'diag-course-select' });
    },
  }
}

</script>

<style scoped>
span {
  margin: 10px;
}

.diagtitlechange-fade-enter-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-leave-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

</style>
